/** How the lab writes what the index returns: fonts, references, shares. */
import { IndexLexeme, LANGUAGES } from '@/components/lemmas/renderer/wordLayer'

/** The font class for a lexeme's script. */
export const font = (l: IndexLexeme | null | undefined): string => (l ? LANGUAGES[l.language].font : '')

/** `Job 22:3`. */
export const verseRef = (r: { book: string; chapter: number; verse: number }): string => `${r.book} ${r.chapter}:${r.verse}`

/** A share as a whole percentage (`62%`); a dash for none. */
export const percent = (x: number | null | undefined): string => (x === null || x === undefined ? '–' : `${Math.round(x * 100)}%`)

